/**
 * 记账模块登录令牌的本地存取。
 *
 * 存的是后端签发的随机令牌，不是密码，也不是密码的密文。
 * 这点很重要：前端做任何加密都挡不住人，因为算法就在 JS 里；
 * 真正的门在后端 —— 没有有效令牌，接口一律 401。
 *
 * 令牌默认 30 天有效，且每次成功请求都会在后端顺延，
 * 所以常用的浏览器基本不用重复输密码。
 */

const TOKEN_KEY = 'jizhang_token'

/** 读取本地令牌 */
export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    // 隐私模式下 localStorage 可能不可用
    return null
  }
}

/** 保存令牌 */
export function setToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch {
    // 存不了就算了，本次会话仍可用，只是下次要重新输密码
  }
}

/** 清除令牌 */
export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch {
    // 忽略
  }
}

/** 本地是否有令牌（不代表一定有效，有效性由后端判定） */
export function hasToken(): boolean {
  const token = getToken()
  return token !== null && token !== ''
}
